import React from "react";
import { Route } from "react-router-dom";

import UserList from "cortex/ui/src/fleet/view/user/UserList";

function renderUserRoutes() {
  return [
    <Route
      component={UserList}
      exact
      key="user"
      path={["/users", `/users/:action(create)`, `/users/:id/:action(edit)`]}
    />,
  ];
}

export { renderUserRoutes };
